import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams} from 'ag-grid-community';
import { NotificationService } from 'shared';
// import { ProjectService } from 'shared';
// import { SquirrelManagementService } from 'shared';
import { TenantService } from 'shared';
// import { TranslateService } from 'shared';

@Component({
    selector: 'user-projects-image-renderer',
    templateUrl: './user-projects-image-renderer.component.html',
    styleUrls: ['./user-projects-image-renderer.component.css'],
    standalone: false
})
export class UserProjectsImageRendererComponent implements ICellRendererAngularComp {

  params!: ICellRendererParams;
  projectData: any;
  img: any;
  projectImage!: string|ArrayBuffer|null|any;


  constructor(
    // public translate: TranslateService,
    private tenantService: TenantService,
    // private managementService: SquirrelManagementService,
    // private projectService: ProjectService,
    private notificationService: NotificationService,
  ){}

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.projectData = (this.params.node.data)?[this.params.node.data]:null;
    //console.log("------> image-renderer projectData=", this.projectData)
    if (this.params.node.data == null) return;
    let tenant:string = this.tenantService.currentTenantName;

    // wenn das Bild in this.projectData.IMAGE steht, dann:

    this.projectImage = (this.projectData[0].image != null) ? "data:image/jpeg;base64," + this.projectData[0].image : null;
     //console.log("-------> image-renderer img=", this.projectImage);


    // this.img = this.projectData[0].image;
    // if (this.img ){
    //     const blobToBase64 = (blob: Blob) => {
    //       console.log("-------> image-renderer blob=", blob);
    //       const reader = new FileReader();
    //       reader.readAsDataURL(blob);
    //       return new Promise(resolve => {
    //         reader.onloadend = () => {
    //           resolve(reader.result);
    //         };
    //       });
    //     };
    //     blobToBase64(this.img).then(res => {
    //       this.projectImage = res as string; //tmp.split(',')[1];
    //       console.log("-------> image-renderer img=", this.projectImage);
    //     });
    // }

    // this.tenantService.getProjectImage(tenant, this.projectData[0].id).subscribe({
    //   next: (result: any) => {
    //     if (result==null){
    //       return;
    //     } 
    //     console.log("-------> image-renderer result=", result);
    //     const blobToBase64 = (blob: Blob) => {
    //       const reader = new FileReader();
    //       reader.readAsDataURL(blob);
    //       return new Promise(resolve => {
    //         reader.onloadend = () => {
    //           resolve(reader.result);
    //         };
    //       });
    //     };
    //     blobToBase64(result).then(res => {
    //       this.projectImage = res as string; //tmp.split(',')[1];
    //       console.log("-------> image-renderer img=", this.projectImage);
    //     });
    //   },
    //   error: (err: any) => {
    //     //console.log("------> image-renderer error=", err)
    //     this.notificationService.error("Fehler", "Lesen des Projektbildes")
    //   }
    // });


    // console.log("------> image-renderer call service")
    // this.tenantService.getProjectImageMesse(tenant, this.projectData[0].id, (result:any) => {
    //   if (result==null){
    //     return;
    //   } 
    //   console.log("-------> image-renderer result=", result);

    //   const blobToBase64 = (blob: Blob) => {
    //     const reader = new FileReader();
    //     reader.readAsDataURL(blob);
    //     return new Promise(resolve => {
    //       reader.onloadend = () => {
    //         resolve(reader.result);
    //       };
    //     });
    //   };
    //   blobToBase64(result).then(res => {
    //     this.projectImage = res as string; //tmp.split(',')[1];
    //     console.log("-------> image-renderer img=", this.projectImage);
    //   });

      // this.blobToBase64(result).then(value => {this.projectImage = value;});
      // console.log("-------> image-renderer img=", this.projectImage);
    // })

  }
  
  // blobToBase64(blob: Blob): Promise<string|ArrayBuffer|null> {
  //   // const reader = new FileReader();
  //   // reader.readAsDataURL(blob);
  //   // return new Promise(resolve => {
  //   //   reader.onloadend = () => {
  //   //     resolve(reader.result);
  //   //   };
  //   // });
  //   return new Promise((resolve, _) => {
  //     const reader = new FileReader();
  //     reader.readAsDataURL(blob);
  //     reader.onloadend = () => resolve(reader.result);
  //     reader.readAsDataURL(blob);
  //   });
  // };
  

}

// loadProjectImageData() {
//   var self = this;
//   this.projectImage = null;
//   if (!this.projectId) return;

//   this.projectsService.projectImage(this.projectId, function(result:any) {
//     if (result==null) return;
//     self.blobToBase64(result).then(value => {self.projectImage = value;});
//   })
// }







// import { Component, OnInit } from '@angular/core';
// import { ICellRendererAngularComp } from 'ag-grid-angular';
// import { ICellRendererParams } from 'ag-grid-community';
// import * as _ from 'lodash';
// import { SquirrelSessionRequest } from 'shared';
// import { NotificationService } from 'shared';
// import { ProjectService } from 'shared';
// import { SquirrelManagementService } from 'shared';
// import { TenantService } from 'shared';
// import { TranslateService } from 'shared';

// @Component({
//   selector: 'user-projects-image-renderer',
//   templateUrl: './user-projects-image-renderer.component.html',
//   styleUrls: ['./user-projects-image-renderer.component.css']
// })
// export class UserProjectsImageRendererComponent implements ICellRendererAngularComp {

//   params!: ICellRendererParams;
//   projectData: any;
//   projectId!: string;

//   constructor() { }
//   refresh(params: ICellRendererParams): boolean {
//     // this.params = params;
//     // this.projectData = [this.params.node.data];
//     //this.projectId = this.projectData[0].id;
//     return false;
//   }
//   agInit(params: ICellRendererParams): void {
//     console.log("--------> image-renderer agInit entry")
//     this.params = params;
//     // this.icon_view = this.params.icon_view;
//     // this.icon_doc = this.params.icon_doc;
//     // this.icon_topic = this.params.icon_topic;
//     // this.routerLinkValue = this.params.routerLinkValue || null;
//     this.refresh(params);
//     //this.refresh(params);
//     this.projectData = (this.params.node.data)?[this.params.node.data]:null;
//     console.log("--------> image-renderer agInit project Id=", this.projectData[0].id)
//     //this.projectId = ;
//   }


// }
